import type { Transition, Variants } from 'motion/react'

/**
 * Motion presets portados 1:1 de v1 (`src/renderer/styles/motion.ts`).
 * Los consumen los primitivos de `components/ui/` y las transiciones de página.
 */

export const duration = {
  fast: 0.15,
  base: 0.25,
  slow: 0.4,
  epic: 0.6
} as const

export const easing = {
  out: [0.16, 1, 0.3, 1] as const,
  inOut: [0.65, 0, 0.35, 1] as const,
  inBack: [0.36, 0, 0.66, -0.56] as const,
  outBack: [0.34, 1.56, 0.64, 1] as const
}

export const spring = {
  soft: { type: 'spring', stiffness: 220, damping: 24, mass: 0.9 } satisfies Transition,
  snappy: { type: 'spring', stiffness: 400, damping: 28, mass: 0.8 } satisfies Transition,
  bouncy: { type: 'spring', stiffness: 320, damping: 14, mass: 1 } satisfies Transition
}

export const stagger = {
  tight: 0.04,
  base: 0.06,
  loose: 0.12
} as const

export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: duration.base, ease: easing.out } }
}

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: duration.base, ease: easing.out } }
}

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: { opacity: 1, scale: 1, transition: spring.soft }
}

export const popIn: Variants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: spring.bouncy }
}

export function staggerContainer(
  childrenStagger: number = stagger.base,
  delayChildren: number = 0
): Variants {
  return {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: childrenStagger,
        delayChildren
      }
    }
  }
}
